<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Редактировать фото профиля</h1>
      <form @submit.prevent="submitPhoto">
        <b-field class="file">
          <b-upload v-model="file">
            <i v-if="!file" class="mdi mdi-upload"></i> {{ file ? file.name : 'Выберите фотографию' }}
          </b-upload>
        </b-field>

        <button class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          Сохранить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
import { toastDanger } from '@/lib/toastCfg'

export default {
  data() {
    return {
      file: null
    }
  },
  methods: {
    submitPhoto() {
      if (this.file.size >= 10000000) {
        this.$buefy.toast.open(toastDanger('Слишком большой размер файла'))
        return
      }
      this.$emit('save', this.file)
    }
  }
}
</script>
